import {getLocalizedText, texts} from '../constants/TextConst';

export const getToday = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
};

export const getYesterday = () => {
    const yesterday = getToday();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday;
};

export const getTomorrow = () => {
    const tomorrow = getToday();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
};

export const getCurrentWeekStarts = () => {
    const curWeekStart = getToday();
    const sundayDate = curWeekStart.getDate() - curWeekStart.getDay();
    curWeekStart.setDate(sundayDate);
    return curWeekStart;
};

export const getCurrentWeekEnds = () => {
    const curWeekEnd = getCurrentWeekStarts();
    const saturday = curWeekEnd.getDate() + 6;
    curWeekEnd.setDate(saturday);
    return curWeekEnd;
};

export const getLastWeekStarts = () => {
    const lastWeekStart = getCurrentWeekStarts();
    lastWeekStart.setDate(lastWeekStart.getDate() - 7);
    return lastWeekStart;
};

export const getLastWeekEnds = () => {
    const lastWeekend = getLastWeekStarts();
    lastWeekend.setDate(lastWeekend.getDate() + 6);
    return lastWeekend;
};

export const getNextWeekStarts = () => {
    const nextWeekStart = getCurrentWeekEnds();
    nextWeekStart.setDate(nextWeekStart.getDate() + 1);
    return nextWeekStart;
};

export const getNextWeekEnds = () => {
    const nextWeekStartDay = getNextWeekStarts();
    nextWeekStartDay.setDate(nextWeekStartDay.getDate() + 6);
    return nextWeekStartDay;
};

export const getCurrentMonthStart = () => {
    const curMonthStart = getToday();
    curMonthStart.setDate(1);
    return curMonthStart;
};

export const getCurrentMonthEnd = () => {
    const curMonthEnd = getToday();
    const curMonth = curMonthEnd.getMonth();
    curMonthEnd.setMonth(curMonth + 1, 0);
    return curMonthEnd;
};

export const getLastMonthStarts = () => {
    const lastMonthStart = getCurrentMonthStart();
    lastMonthStart.setMonth(lastMonthStart.getMonth() - 1, 1);
    return lastMonthStart;
};

export const getLastMonthEnds = () => {
    const lastMonthend = getLastMonthStarts();
    lastMonthend.setMonth(lastMonthend.getMonth() + 1, 0);
    return lastMonthend;
};

export const getNextMonthStarts = () => {
    const nextMonthStart = getCurrentMonthEnd();
    nextMonthStart.setDate(nextMonthStart.getDate() + 1);
    return nextMonthStart;
};

export const getNextMonthEnds = () => {
    const nextMonthEnds = getNextMonthStarts();
    nextMonthEnds.setMonth(nextMonthEnds.getMonth() + 1, 0);
    return nextMonthEnds;
};

export const getCurrentQuarterStarts = () => {
    const curDay = getToday();
    const year = curDay.getFullYear();
    const curMonth = curDay.getMonth();
    let curQuarterMonth;
    if (curMonth <= 2) curQuarterMonth = 0;
    else if (curMonth <= 5) curQuarterMonth = 3;
    else if (curMonth <= 8) curQuarterMonth = 6;
    else if (curMonth <= 11) curQuarterMonth = 9;
    const currentQuarterStart = new Date(year, curQuarterMonth, 1);
    return currentQuarterStart;
};

export const getCurrentQuarterEnds = () => {
    const currentQuarterStart = getCurrentQuarterStarts();
    const currentQuarterEndMonth = currentQuarterStart.getMonth() + 3;
    const currentQuarterEnd = new Date(currentQuarterStart.setMonth(currentQuarterEndMonth, 0));
    return currentQuarterEnd;
};

export const getNextQuarterStarts = () => {
    const nextQuarterStart = getCurrentQuarterEnds();
    nextQuarterStart.setDate(nextQuarterStart.getDate() + 1);
    return nextQuarterStart;
};

export const getNextQuarterEnds = () => {
    const nqs = getNextQuarterStarts();
    const nextQuarterEndMonth = (nqs.getMonth() + 3) % 12;
    nqs.setMonth(nextQuarterEndMonth, 0);
    return nqs;
};

export const getLastQuarterStarts = () => {
    const currentQuarterStart = getCurrentQuarterStarts();
    const lastQuarterMonth = currentQuarterStart.getMonth() - 3;
    const lastQuarterStart = new Date(currentQuarterStart.setMonth(lastQuarterMonth));
    return lastQuarterStart;
};

export const getLastQuarterEnds = () => {
    const currentQuarterStart = getCurrentQuarterStarts();
    const lastQuarterEnd = new Date(currentQuarterStart.setDate(0));
    return lastQuarterEnd;
};

export const getCurrentYearStarts = () => {
    const yearStart = getToday();
    yearStart.setMonth(0, 1);
    return new Date(yearStart);
};

export const getCurrentYearEnds = () => {
    const yearEnd = getToday();
    yearEnd.setMonth(11 + 1, 0);
    return new Date(yearEnd);
};

const getNextYearStarts = () => {
    const nextYear = new Date().getFullYear() + 1;
    return new Date(nextYear, 0, 1);
};

const getNextYearEnds = () => {
    const nextYear = new Date().getFullYear() + 1;
    return new Date(nextYear, 11 + 1, 0);
};

const getLastYearStarts = () => {
    const curDay = new Date();
    const lastYear = curDay.getFullYear() - 1;
    return new Date(lastYear, 0, 1);
};

const getLastYearEnds = () => {
    const curDay = new Date();
    const year = curDay.getFullYear();
    return new Date(year, 0, 0);
};

export enum DateRangeID {
    today = '501',
    tomorrow = '502',
    yesterday = '500',
    startThisWeek = '503',
    endThisWeek = '504',
    startThisMonth = '505',
    endThisMonth = '506',
    startThisQuarter = '507',
    endThisQuarter = '508',
    startThisYear = '509',
    endThisYear = '510',
    startLastWeek = '511',
    endLastWeek = '512',
    startLastMonth = '513',
    endLastMonth = '514',
    startLastQuarter = '515',
    endLastQuarter = '516',
    startLastYear = '517',
    endLastYear = '518',
    startNextWeek = '519',
    endNextWeek = '520',
    startNextMonth = '521',
    endNextMonth = '522',
    startNextQuarter = '523',
    endNextQuarter = '524',
    startNextYear = '525',
    endNextYear = '526'
}

let dateRangesMap;
export const buildDateRangeMap = () => {
    dateRangesMap = {
        [DateRangeID.today]: {
            getDate: getToday,
            label: getLocalizedText(texts.today)
        },
        [DateRangeID.tomorrow]: {
            getDate: getTomorrow,
            label: getLocalizedText(texts.tomorrow)
        },
        [DateRangeID.yesterday]: {
            getDate: getYesterday,
            label: getLocalizedText(texts.yesterday)
        },
        [DateRangeID.startThisWeek]: {
            getDate: getCurrentWeekStarts,
            label: getLocalizedText(texts.currentWeekStart)
        },
        [DateRangeID.endThisWeek]: {
            getDate: getCurrentWeekEnds,
            label: getLocalizedText(texts.currentWeekEnd)
        },
        [DateRangeID.startThisMonth]: {
            getDate: getCurrentMonthStart,
            label: getLocalizedText(texts.currentMonthStart)
        },
        [DateRangeID.endThisMonth]: {
            getDate: getCurrentMonthEnd,
            label: getLocalizedText(texts.currentMonthEnd)
        },
        [DateRangeID.startThisQuarter]: {
            getDate: getCurrentQuarterStarts,
            label: getLocalizedText(texts.currentQuarterStart)
        },
        [DateRangeID.endThisQuarter]: {
            getDate: getCurrentQuarterEnds,
            label: getLocalizedText(texts.currentQuarterEnd)
        },
        [DateRangeID.startThisYear]: {
            getDate: getCurrentYearStarts,
            label: getLocalizedText(texts.currentYearStart)
        },
        [DateRangeID.endThisYear]: {
            getDate: getCurrentYearEnds,
            label: getLocalizedText(texts.currentYearEnd)
        },
        [DateRangeID.startLastWeek]: {
            getDate: getLastWeekStarts,
            label: getLocalizedText(texts.lastWeekStart)
        },
        [DateRangeID.endLastWeek]: {
            getDate: getLastWeekEnds,
            label: getLocalizedText(texts.lastWeekEnd)
        },
        [DateRangeID.startLastMonth]: {
            getDate: getLastMonthStarts,
            label: getLocalizedText(texts.lastMonthStart)
        },
        [DateRangeID.endLastMonth]: {
            getDate: getLastMonthEnds,
            label: getLocalizedText(texts.lastMonthEnd)
        },
        [DateRangeID.startLastQuarter]: {
            getDate: getLastQuarterStarts,
            label: getLocalizedText(texts.lastQuarterStart)
        },
        [DateRangeID.endLastQuarter]: {
            getDate: getLastQuarterEnds,
            label: getLocalizedText(texts.lastQuarterEnd)
        },
        [DateRangeID.startLastYear]: {
            getDate: getLastYearStarts,
            label: getLocalizedText(texts.lastYearStart)
        },
        [DateRangeID.endLastYear]: {
            getDate: getLastYearEnds,
            label: getLocalizedText(texts.lastYearEnd)
        },
        [DateRangeID.startNextWeek]: {
            getDate: getNextWeekStarts,
            label: getLocalizedText(texts.nextWeekStart)
        },
        [DateRangeID.endNextWeek]: {
            getDate: getNextWeekEnds,
            label: getLocalizedText(texts.nextWeekEnd)
        },
        [DateRangeID.startNextMonth]: {
            getDate: getNextMonthStarts,
            label: getLocalizedText(texts.nextMonthStart)
        },
        [DateRangeID.endNextMonth]: {
            getDate: getNextMonthEnds,
            label: getLocalizedText(texts.nextMonthEnd)
        },
        [DateRangeID.startNextQuarter]: {
            getDate: getNextQuarterStarts,
            label: getLocalizedText(texts.nextQuarterStart)
        },
        [DateRangeID.endNextQuarter]: {
            getDate: getNextQuarterEnds,
            label: getLocalizedText(texts.nextQuarterEnd)
        },
        [DateRangeID.startNextYear]: {
            getDate: getNextYearStarts,
            label: getLocalizedText(texts.nextYearStart)
        },
        [DateRangeID.endNextYear]: {
            getDate: getNextYearEnds,
            label: getLocalizedText(texts.nextYearEnd)
        }
    };
};

export const getDateRanges = () => {
    if (!dateRangesMap) {
        buildDateRangeMap();
    }

    return Object.keys(dateRangesMap).map(key => ({value: key, ...dateRangesMap[key]}));
};

export const getDateRangesMap = () => {
    if (!dateRangesMap) {
        buildDateRangeMap();
    }
    return dateRangesMap;
};
